<template>
  <v-container>
    <div v-if="status === 0">
      <TopPreparation/>
    </div>
    <div v-else-if="status === 2">
      <TopAlert/>
    </div>
    <div v-else-if="status === 3">
      <TopReady/>
    </div>
    <div v-else-if="status === 4">
      <TopFalseAlert/>
    </div>
    <div v-else>
      <Top/>
    </div>
  </v-container>
</template>

<script>
import Top from './PC/Top'
import TopAlert from './PC/TopAlert'
import TopPreparation from './PC/TopPreparation'
import TopReady from './PC/TopReady'
import TopFalseAlert from './PC/TopFalseAlert'

export default {
  props: {
    status: Number,
  },
  components: {
    Top,
    TopPreparation,
    TopAlert,
    TopReady,
    TopFalseAlert
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  max-width: none;
  margin: 0px;
  padding: 0px;

}
</style>
